import React from "react";
import style from "./OurStory.module.css";
import { Title } from "../Title";
import { Button } from "../../ui";
import { RouteNames } from "../../router";
import background from "../../assets/our-srory-background.png";

export const OurStory = () => {
  return (
    <div
      style={{ backgroundImage: `url(${background})` }}
      className={style.ourStoryContainer}
    >
      <div className="container">
        <Title
          mb={"40px"}
          title={"Our story"}
          text={"Why we started it?"}
          color={"white"}
        />
        <p className={style.ourStoryText}>
          HomeCraft Masters is a family-owned Colorado company with more than
          20 years of experience in custom kitchen design and cabinetry. We
          bring European-inspired design and Ukrainian craftsmanship to every
          project, combining your ideas with durable materials and thoughtful
          details to create a kitchen made for your home.
        </p>
        <Button path={RouteNames.ABOUT} text={"Learn more"} />
      </div>
    </div>
  );
};
